import { render, staticRenderFns } from "./Tabel.vue?vue&type=template&id=28e8ef6f&scoped=true"
import script from "./Tabel.vue?vue&type=script&lang=js"
export * from "./Tabel.vue?vue&type=script&lang=js"
import style0 from "./Tabel.vue?vue&type=style&index=0&id=28e8ef6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e8ef6f",
  null
  
)

export default component.exports